import { ColumnType } from '@dynamika-shared/ui/Table/Table.types';
import { TeamMember, Feature } from '@dynamika-shared/types/teamMember';
import { CustomTooltip } from '@dynamika-shared/ui/Tooltip/CustomTooltip';
import { UserInfo } from '@components/UserInfo/UserInfo';
import { UserRoles } from '@dynamika-shared/types/auth';
import { rolesMap } from 'src/constants/rolesList';
import { loadingSkeleton, tooltipClassName } from './tableUtils';
import { EyeIcon } from '@dynamika-shared/ui/icons';

export const baseTeamMemberColumns: ColumnType<TeamMember>[] = [
  {
    name: 'fullName',
    header: () => 'Full Name',
    loading: index =>
      loadingSkeleton(Number(index) % 2 ? `w-[${20}rem]` : `w-[${17}rem]`),
    getValue: row => (
      <UserInfo
        fullName={row.fullName}
        email={row.email}
        enabled={row.enabled}
        className={'max-w-[calc(100%-2rem)]'}
        classNameText={'max-w-[calc(100%-2rem)]'}
      />
    ),
    hasSorting: true,
    thClassName: 'w-[25rem] min-w-[18%] max-w-[18%]',
  },
  {
    name: 'roles',
    header: () => 'Role',
    loading: index =>
      loadingSkeleton(Number(index) % 2 ? `w-[${13}rem]` : `w-[${10}rem]`),
    getValue: row => {
      const hasReadingEnabled = row.features?.includes(Feature.FEATURE_VIEW_SCORING_TASK);
      const hasLabeledViewEnabled = row.features?.includes(Feature.FEATURE_VIEW_LABELED_SERIES);

      return (
        <div className='flex flex-col justify-center gap-0'>
          <CustomTooltip
            label={rolesMap[row.roles as UserRoles]?.label ?? row.roles}
            className={tooltipClassName(row.enabled)}
          />
          {((hasReadingEnabled || hasLabeledViewEnabled) && (
              <div className='flex  gap-0.5 text-gray-500 text-[10px] -mt-0.5'>
                <EyeIcon className='w-2.5 h-2.5' />
                <span>Read-only readings enabled</span>
              </div>
            ))}
        </div>
      );
    },
    hasSorting: true,
    thClassName: 'w-[20rem] min-w-[11rem] max-w-[11%]',
  },
];
